module.exports = __webpack_public_path__ + "img/0Q3A5767_L_Foamcore.80ba2acf.jpg";